import { useMediaQuery } from '@mui/material';

/**
 * Whether the mobile layout is the one being rendered: true at phone widths, below the `sm`
 * breakpoint (600px); tablets and narrow desktop windows get the desktop layout. Read this rather
 * than a viewport query of your own, so every caller switches on the same line.
 */
const useMobileMode = function useMobileMode() {
  return useMediaQuery((theme) => theme.breakpoints.down('sm'), {
    noSsr: true,
  });
};

export default useMobileMode;
